
// Environment constants
export const OLMS_API_HOST = import.meta.env.VITE_APP_OLMS_API_HOST
export const OLMS_WHITE_LABEL = import.meta.env.VITE_APP_OLMS_WHITE_LABEL
export const OLMS_API_KEY = import.meta.env.VITE_APP_OLMS_API_KEY

export const FASTMILE_API_HOST = import.meta.env.VITE_APP_FASTMILE_API_HOST
export const FASTMILE_API_KEY = import.meta.env.VITE_APP_FASTMILE_API_KEY

export const HERE_GEOCODE_API_KEY = import.meta.env.VITE_APP_HERE_GEOCODE_API_KEY
export const HERE_API_KEY = import.meta.env.VITE_APP_HERE_API_KEY

// Stripe Publishable Key
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY

// Widgets UI constants
export const MAX_WINDOW_COUNT = 8
export const MOSAIC_LAYOUT_ID = 'mosaic'

// Local Storage keys
export const PLANNING_MOSAIC_LAYOUT_LOCAL_STORAGE_KEY = 'planning-mosaic-layout'
export const PLANNING_WIDGET_TOOLBAR_LOCAL_STORAGE_KEY = 'planning-widget-toolbar'
export const PLANNING_TREE_EXPENDED_KEYS_LOCAL_STORAGE_KEY = 'planning-tree-expanded-keys'
export const PLANNING_TREE_SHOW_UTILISATION_PIES_LOCAL_STORAGE_KEY = 'planning-tree-show-pies'

export const RUNSHEET_MOSAIC_LAYOUT_LOCAL_STORAGE_KEY = 'runsheet-mosaic-layout'
export const RUNSHEET_WIDGET_TOOLBAR_LOCAL_STORAGE_KEY = 'runsheet-widget-toolbar'
export const RUNSHEET_TREE_EXPENDED_KEYS_LOCAL_STORAGE_KEY = 'runsheet-tree-expanded-keys'
export const RUNSHEET_TREE_SHOW_UTILISATION_PIES_LOCAL_STORAGE_KEY = 'planning-tree-show-pies'

// Geocode & Region constants
export const AVAILABLE_COUNTRIES = ['United States', 'New Zealand', 'Australia']

// Here Map Default and constants
export const DEFAULT_MAP_CENTER_LAT = -37.810246
export const DEFAULT_MAP_CENTER_LON = 144.962768
export const DEFAULT_MAP_ZOOM = 10